import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { StatusBadge } from '../StatusBadge';

export function ClientHeader({ client }) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 bg-background border-b border-border z-10 p-4">
      <button
        onClick={() => navigate('/clients')}
        className="flex items-center gap-2 text-text-secondary hover:text-foreground mb-4 transition-colors"
        data-testid="back-to-clients"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>Back</span>
      </button>
      <div className="flex items-center gap-3">
        <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center text-background text-2xl font-medium">
          {client.name.charAt(0).toUpperCase()}
        </div>
        <div className="flex-1">
          <h1 className="text-2xl font-serif font-bold text-foreground mb-1" data-testid="client-name">
            {client.name}
          </h1>
          <div className="flex items-center gap-2">
            <StatusBadge status={client.status} />
            {client.email && <span className="text-sm text-text-secondary">{client.email}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
